import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { uxReducerPath } from './const';
import { UXState } from './types';

export * from './const';
export * from './selectors';
export * from './types';

const initialState: UXState = {
  loginShown: false,
  needHelpShownForGuest: false,
  needHelpShownForRegisteredUser: false,
  notificationsSubscribeReminderLastShownInMs: undefined,
};

export const UXSlice = createSlice({
  name: `@@app/${uxReducerPath}`,
  initialState,
  reducers: {
    setloginShown(state, action: PayloadAction<UXState['loginShown']>) {
      state.loginShown = action.payload;
    },
    setNeedHelpShownForGuest(state, action: PayloadAction<UXState['needHelpShownForGuest']>) {
      state.needHelpShownForGuest = action.payload;
    },
    setNeedHelpShownForRegisteredUser(state, action: PayloadAction<UXState['needHelpShownForRegisteredUser']>) {
      state.needHelpShownForRegisteredUser = action.payload;
    },
    setNotificationsSubscribeReminderLastShownInMs(state) {
      state.notificationsSubscribeReminderLastShownInMs = Date.now();
    },
  },
});
